import { useMutation } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api';

function Header() {
  return <header className="legacy-public-header">
    <Link to="/login"><img src="/logo-square-dark.png" alt="EPOS Bookings" /></Link>
    <nav>
      <Link className="legacy-login-nav-button" to="/login">Login</Link>
    </nav>
  </header>;
}

export function ActivationPage({ userId, token }: { userId: number; token: string }) {
  const activation = useMutation({ mutationFn: () => api.publicAccounts.activate(userId, token) });
  const started = useRef(false);

  useEffect(() => {
    if (!started.current) {
      started.current = true;
      activation.mutate();
    }
  }, []);

  return <main className="legacy-login-page">
    <Header />
    <div className="registration-success">
      <img src="/logo-light.svg" alt="Epos Bookings" />
      {activation.isPending
        ? <h1>Activating Account…</h1>
        : activation.isError
          ? <><h1>Activation Failed</h1><p>{activation.error.message}</p></>
          : <><h1>Email Verified</h1><p>Your account is now active.</p><Link className="legacy-submit activation-preview" to="/login">Continue to login</Link></>}
    </div>
  </main>;
}
